module.exports = __webpack_public_path__ + "img/sameday_dg.572fef90.png";